var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoupanca(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 7.70001C10.2002 5.40001 14.2002 3.5 19.2002 3.5C24.2002 3.5 28.2002 5.40001 28.2002 7.70001C28.2002 10 24.2002 11.9 19.2002 11.9C14.2002 11.9 10.2002 10 10.2002 7.70001ZM10.2002 7.70001V34.4C10.2002 36.7 14.2002 38.6 19.2002 38.6M28.3002 21.1V7.79999M10.2002 14.4C10.2002 16.7 14.2002 18.6 19.2002 18.6C24.2002 18.6 28.2002 16.7 28.2002 14.4M10.2002 21.1C10.2002 23.4 14.2002 25.3 19.2002 25.3M10.2002 27.7C10.2002 30 14.2002 31.9 19.2002 31.9M20.2002 32.6C20.2002 34.9 24.2002 36.8 29.2002 36.8C34.2002 36.8 38.2002 34.9 38.2002 32.6M20.2002 26V39.3C20.2002 41.6 24.2002 43.5 29.2002 43.5C34.2002 43.5 38.2002 41.6 38.2002 39.3V26M20.2002 26C20.2002 28.3 24.2002 30.2 29.2002 30.2C34.2002 30.2 38.2002 28.3 38.2002 26M20.2002 26C20.2002 23.7 24.2002 21.8 29.2002 21.8C34.2002 21.8 38.2002 23.7 38.2002 26",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoupanca);
export default __webpack_public_path__ + "static/media/poupanca.1d089ba9a18fc5045efb8a7d2282d94d.svg";
export { ForwardRef as ReactComponent };